import { portfolioConfig } from '../../../config';

export const fullName = portfolioConfig.fullName;
export const bio = portfolioConfig.bio;
export const githubUrl = portfolioConfig.githubUrl;
export const linkedinUrl = portfolioConfig.linkedinUrl;
export const siteTitle = portfolioConfig.title;
export const resumeDownloadFilename = portfolioConfig.resumeDownloadFilename;
